<template>
    <div class="input-field" v-on:click="focus()" :class="{ error: (isValid == false), label: (label != '')}">
        <input type="text" :name="name" :placeholder="placeholder" v-model="inputField" ref="inputField" :required="required" :maxlength="limit>0 ? limit: false" />
        <label :for="name" v-if="label != ''">{{ label }}</label>
        <div v-if="isTyping" @click="clearField()">
            <Icon icon="clear"></Icon>
        </div>
        <Icon :icon="icon" v-else-if="icon.length>0"></Icon>
    </div>
</template>

<script>
    import Icon from "./Icon";
    export default {
        name: "InputField",
        components: {Icon},
        props: {
            'name': {
                type: String,
                required: true
            },
            'icon': {
                type: String,
                default: ''
            },
            'label': {
                type: String,
                default: ''
            },
            'placeholder': {
                type: String,
                default: ''
            },
            'required': {
                type: Boolean,
                default: false
            },
            'pattern': {
                type: String,
                default: ''
            },
            'submitted': {
                type: Boolean,
                default: false
            },
            'limit': {
                type: Number,
                default: 0
            }
        },
        data: function () {
            return {
                value: '',
                validator: new RegExp(this.pattern),
                edited: false
            }
        },
        created() {
            //  set field as invalid if required
            this.$store.commit('setErrorStatus', {
                type: this.name,
                status: this.required
            });

            // set default value
            this.$store.commit('setFieldValue', {
                field: this.name,
                value: ''
            });
        },
        computed: {
            inputField: {
                get() {
                    // get store value
                    let value  = this.$store.state.fieldValues[this.name]

                    // ensure string is returned
                    this.value = (value === undefined)? '': value;

                    return this.value;
                },
                set(value) {
                    this.value = value;
                    this.edited = true;

                    this.$store.commit('setFieldValue', {
                        field: this.name,
                        value: value
                    });
                }
            },
            /**
             * validate value if a pattern is set
             */
            isValid: function() {
                if(this.pattern.length > 0) {
                    // show as valid if field was not edited
                    if (!this.edited && !this.submitted)
                        return true;

                    /**
                     * - is valid if not required and empty
                     * - is valid if value matches pattern and not longer as limit length x(if set)
                     */
                    let isValid = (
                        (!this.required && (this.value.length == 0))
                        || (this.validator.test(this.value) && ((this.limit <= 0) || (this.limit >= this.value.length)))
                    );


                    // commit error status (true == error)
                    this.$store.commit('setErrorStatus', {
                        type: this.name,
                        status: !isValid
                    });

                    if (isValid) {
                        // emit valid event
                        this.$emit('valid')
                    } else {
                        // set focus on input
                        // this.$refs.inputField.focus();
                        // emit invalid event
                        this.$emit('invalid');
                    }

                    return isValid;
                }
            },
            /**
             * check if field is not empty
             */
            isTyping: function () {
                return (this.value.length > 0);
            },
        },
        methods: {
            /**
             * set focus on input field
             */
            focus() {
                this.$refs.inputField.focus();
            },
            /**
             * reset field value
             */
            clearField () {
                this.value = '';
                this.$store.commit('setFieldValue', {
                    field: this.name,
                    value: ''
                });
            }
        }
    }
</script>
